const listeners = {};

const keyCodesToKeys = {
  49: '1',
  97: '1',
  50: '2',
  98: '2',
  51: '3',
  99: '3',
  52: '4',
  100: '4',
  53: '5',
  101: '5',
  54: '6',
  102: '6',
  55: '7',
  103: '7',
  56: '8',
  104: '8',
  57: '9',
  105: '9',
  32: ' ',
  38: 'ArrowUp',
  40: 'ArrowDown',
  37: 'ArrowLeft',
  39: 'ArrowRight',
  13: 'Enter',
  107: '+',
  73: 'i',
  65: 'a',
  27: 'Escape',
};
// if(!process.env.BUILD_TYPE.includes('test')){
document.addEventListener('keyup', onKeyUp);
window.focus();

// }
function onKeyUp(e) {
  const pressedKey = e.key || keyCodesToKeys[e.keyCode];
  const callbacksData = listeners[pressedKey];
  if (callbacksData) {
    for (const d of callbacksData) {
      d.listener.call(d.context, pressedKey, e);
    }
  }
}

export function addKeyboardListener(key, listener, context = null) {
  const keys = Array.isArray(key) ? key : [key];
  for (const k of keys) {
    const data = listeners[k];
    if (data) {
      if (!data.find((a) => a.listener === listener && a.context === context))
        data.push({
          listener,
          context,
        });
    } else {
      listeners[k] = [
        {
          listener,
          context,
        },
      ];
    }
  }
  return () => {
    for (const k of keys) removeListener(k, listener, context);
  };
}

function removeListener(key, listener, context) {
  if (listeners[key]) {
    listeners[key] = listeners[key].filter((a) => a.listener !== listener || a.context !== context);
  }
}
